import React from 'react';
import PropTypes from 'prop-types';
import { Modal, FooterButton } from 'Core/components';

const ConfirmModal = ({
  showModal,
  title = 'Confirm',
  message = 'Do you confirm the action?',
  onCloseModal,
  onConfirmModal,
  isLoading = false,
  confirmText = 'Confirm',
}) => {
  const body = () => (
    <div className="row">
      <div className="col-12">{message}</div>
    </div>
  );

  const handleClose = () => {
    if (!isLoading) {
      onCloseModal();
    }
  };

  const onConfirm = () => {
    if (!isLoading) {
      onConfirmModal();
    }
  };

  const footer = () => (
    <FooterButton
      cancelText="Cancel"
      saveText={isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Processing...
        </>
      ) : confirmText}
      onSave={onConfirm}
      onCancel={handleClose}
      disableSave={isLoading}
      disableCancel={isLoading}
    />
  );

  return (
    <Modal
      id="confirm-modal"
      show={showModal}
      size="md"
      title={title}
      body={body}
      footer={footer}
      handleClose={isLoading ? () => {} : handleClose}
    />
  );
};

ConfirmModal.propTypes = {
  showModal: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  onCloseModal: PropTypes.func,
  onConfirmModal: PropTypes.func,
  isLoading: PropTypes.bool,
  confirmText: PropTypes.string,
};

export default ConfirmModal;
